import React, { useState } from 'react';
import { TAB_ROUTES } from '../common/config/tab.routes';
import { Link, NavLink } from 'react-router-dom';

const TabNavigator = ({ routes }: any) => {
  const [isLinkActive, setIsLinkActive] = useState(false);
  return (
    <div className='w-full h-full text-white bg-foreground grid grid-cols-3 rounded-xl'>
      {TAB_ROUTES.map((route) => {
        return (
          <div key={route.label} className='flex items-center justify-center'>
            <NavLink
              to={route.path}
              className={({ isActive }) =>
                isActive
                  ? ' flex items-center justify-center bg-secondary-foreground/20 p-2 px-4 h-fit w-fit rounded-full text-secondary '
                  : ' flex items-center justify-center h-fit w-fit '
              }
            >
              <div>{route.icon}</div>
              <span className='text-xs ml-2'>{route.label}</span>
            </NavLink>
          </div>
        );
      })}
    </div>
  );
};

export default TabNavigator;
